import names from '../actions/actionNames';
import initialState from '../initialState';

const rolesInitialState = { ...initialState.roles };

const rolesReducers = (state = rolesInitialState, action) => {
  switch (action.type) {
    case names.LOAD_ROLES_DATA_STARTED:
      return { ...rolesInitialState, loading: true };
    case names.LOAD_ROLES_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case names.LOAD_ROLES_DATA_SUCCESS: {
      const { role, microproducts, airlines } = action.payload;
      return {
        ...state,
        role,
        microproducts,
        airlines,
        loading: false
      };
    }
    case names.CLEAN_ROLE_DATA:
      return { ...rolesInitialState };
    default:
      return state;
  }
};

export default rolesReducers;
